export default __webpack_public_path__ + "static/media/Internship.9b3decb5.jpeg";